import type { InterventionDuplicateFormProps } from "./intervention-duplicate-form.type";

import { Checkbox, Form } from "antd";
import { useTranslation } from "react-i18next";

import { ModelDuplicateForm } from "@/modules/model-duplicate";
import { Alert } from "@/ui/alert";

import { useInterventionDuplicateForm } from "./intervention-duplicate-form.hook";

import "./intervention-duplicate-form.style.less";

const InterventionDuplicateForm = (props: InterventionDuplicateFormProps) => {
  const { t } = useTranslation();
  const {
    form,
    formId,
    initialValues,
    onFormSubmit,
    isPending,
    validation,
    validationErrors,
  } = useInterventionDuplicateForm(props);

  return (
    <ModelDuplicateForm
      form={form}
      formId={formId}
      initialValues={initialValues}
      onFormSubmit={onFormSubmit}
      loading={isPending}
      validation={validation}
      validationErrors={validationErrors}
      customFields={
        <>
          <Form.Item
            name="duplicate_content"
            valuePropName="checked"
            {...validation("duplicate_content")}
          >
            <Checkbox>{t("intervention:duplicate.checkbox.label")}</Checkbox>
          </Form.Item>
          <Alert
            display
            type="info"
            title={t("intervention:duplicate.checkbox.info")}
            className="intervention-duplicate-form-checkbox-alert"
          />
        </>
      }
    />
  );
};

export default InterventionDuplicateForm;
